<template>
    <card-skeleton>
        <v-card-item>
            <card-title size="28" :text="ticketTitle" />
        </v-card-item>
        <v-card-text v-if="isRecentPendingOrders" class="px-3 py-0 mt-2">
            <notification :message="t('buyTicket.cardOnTheWay')" />
        </v-card-text>
        <buy-ticket-content class-name="text-size-md">
            <button-with-description
                data-id="orderNewKolumbusCardButton"
                class-name="mt-5 mb-6"
                :text="t('buyTicket.newKolumbusCard')"
                :link="generateOrderUrl('order-travelcard')"
            >
                <span class="mr-2">
                    {{ t(getDescription('buyTicket.buyTicketDescription')) }}
                </span>
            </button-with-description>
            <button-with-description
                data-id="addTravelCardButton"
                :text="t('travelCard.travelCardCreateTitle')"
                class-name="mb-3"
                @click="toggleForm"
            >
                <span class="mr-2 pointer-events-none">
                    {{ t(getDescription('buyTicket.registerCardDescription')) }}
                </span>
            </button-with-description>
            <add-travel-card-form :is-re-check-needed="false" :is-visible="isFormVisible" @update:is-visible="isFormVisible = $event" />
        </buy-ticket-content>
    </card-skeleton>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import CardTitle from '@/features/common/components/CardTitle.vue';
import CardSkeleton from '@/features/common/components/CardSkeleton.vue';
import BuyTicketContent from '../components/BuyTicketContent.vue';
import { generateUrl } from '@/helpers';
import { useAppConfiguration } from '@/composables';
import { AddTravelCardForm } from '@/features/TravelCards/components/form';
import ButtonWithDescription from '@/features/common/components/ButtonWithDescription.vue';
import Notification from '@/features/common/components/NotificationCard.vue';
import { useCardStore } from '@/features/TravelCards/store/cardStore';
import { storeToRefs } from 'pinia';

const { t } = useI18n();
const { config, language } = useAppConfiguration();
const cardStore = useCardStore();
const { isRecentPendingOrders, getItemCount } = storeToRefs(cardStore);

const isFormVisible = ref(false);

const getDescription = computed(
    () => (translationString: string) => (getItemCount.value ? translationString : `${translationString}Empty`)
);

const ticketTitle = computed(() => {
    return getItemCount.value ? t('buyTicket.buyTicketTitle') : t('buyTicket.buyTicketEmptyTitle');
});

const toggleForm = () => (isFormVisible.value = !isFormVisible.value);

const generateOrderUrl = (path: string) => generateUrl(config.value.webshopBaseUrl, language.value, path);
</script>
